import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { InMemoryCache } from '@apollo/client/core';
import { APOLLO_OPTIONS, ApolloModule } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';

// Modules
import { HeaderModule } from '../navigation/header/header.module';

// Components
import { AppComponent } from './app.component';

// Other local files to utilize in the AppModule
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EffectsModule } from '@ngrx/effects';
import { environment } from '../environments/environment';
import { AuthenticationService } from '../navigation/nav-shared/authentication.service';
import { reducerProvider, reducerToken } from '../ngrx/reducers';
import { AppRoutingModule } from './app-routing.module';
import { AppService } from './app.service';
import { AcgModule } from './shared/components/acg/acg.module';
import { ErrorModule } from './shared/components/error/error.module';
import { FoldAwareSectionModule } from './shared/optimization/fold-aware-section/fold-aware-section.module';

const apolloProvider = {
  provide: APOLLO_OPTIONS,
  useFactory: (httpLink: HttpLink) => {
    return {
      cache: new InMemoryCache(),
      link: httpLink.create({
        // Use apiOrigin in local so GraphQL is same-origin (proxy) and avoids CORS preflight.
        uri: `${
          (environment as any).apiOrigin !== undefined
            ? (environment as any).apiOrigin
            : environment.domain
        }/api/v1/graphql`,
      }),
    };
  },
  deps: [HttpLink],
};

const NavigationModules = [HeaderModule];

@NgModule({
  declarations: [AppComponent],
  imports: [
    AcgModule,
    ApolloModule,
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    ErrorModule,
    FoldAwareSectionModule,
    HttpClientModule,
    StoreModule.forRoot(reducerToken),
    ...NavigationModules,
    !environment.production ? StoreDevtoolsModule.instrument({ maxAge: 50 }) : [],
    EffectsModule.forRoot([]),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [AuthenticationService, AppService, apolloProvider, reducerProvider],
  bootstrap: [AppComponent],
})
export class AppModule {}
